import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [ 
        //首页
        {
            path: '/',
            name:'/',
            component: () => import("@/pages/Home/HomeIndex.vue"),
        },
        // 心理测评
        {
            path: '/appraisal',
            name:'/appraisal',
            component: () => import("@/pages/Home/AppraisalIndex.vue")
        },
        // 咨询师预约
        {
            path: '/subscribe',
            name:'/subscribe',
            component: () => import("@/pages/Home/SubscribeIndex.vue")
        },
        // 咨询师预约详情
        {
            path: '/subscribeDetails',
            name:'/subscribeDetails',
            component: () => import("@/pages/Home/SubscribeDetails.vue")
        },
        // 文章阅读
        {
            path: '/essay',
            name:'/essay',
            component: () => import("@/pages/Home/EssayIndex.vue")
        },
        // 文章详情
        {
            path: '/details',
            name:'/details',
            component: () => import("@/pages/Home/EssayDetails.vue")
        },
        // 会员选择
        {
            path: '/select',
            name:'/select',
            component: () => import("@/pages/Home/SelectClub.vue")
        },
        // 个人中心
        {
            path: '/my',
            name:'/my',
            component: () => import("@/pages/Home/MyIndex.vue")
        },
        // 咨询师个人中心
        {
            path: '/counselor',
            name:'/counselor',
            component: () => import("@/pages/Home/CounselorMy.vue")
        },
        // 平台问答列表
        {
            path: '/terrace',
            name:'/terrace',
            component: () => import("@/pages/Home/TerraceIndex.vue")
        },
        // 平台问答详情
        {
            path: '/terraceDetails',
            name:'/terraceDetails',
            component: () => import("@/pages/Home/TerraceDetails.vue")
        },
        // 登录
        {
            path: '/login',
            name:'/login',
            component: () => import("@/pages/Login/LoginIndex.vue")
        },

        // 基本信息
        {
            path: '/editPersonage',
            name:'/editPersonage',
            component: () => import("@/pages/MyPersonage/EditPersonage.vue")
        },
        // 私信列表
        {
            path: '/letter',
            name:'/letter',
            component: () => import("@/pages/MyPersonage/LetterList.vue")
        },
        // 问答列表
        {
            path: '/answers',
            name:'/answers',
            component: () => import("@/pages/MyPersonage/AnswersList.vue")
        },
        // 预约订单
        {
            path: '/make',
            name:'/make',
            component: () => import("@/pages/MyPersonage/MakeIndex.vue")
        },
        // 会员订单
        {
            path: '/member',
            name:'/member',
            component: () => import("@/pages/MyPersonage/MemberList.vue")
        },
        // 测试记录
        {
            path: '/record',
            name:'/record',
            component: () => import("@/pages/MyPersonage/TestRecord.vue")
        },
        // 咨询师入驻申请
        {
            path: '/apply',
            name:'/apply',
            component: () => import("@/pages/MyPersonage/ApplyIndex.vue")
        },


        // 咨询师基本信息
        {
            path: '/editCounselor',
            name:'/editCounselor',
            component: () => import("@/pages/MyCounselor/EditCounselor.vue")
        },
        // 预约信息
        {
            path: '/appointment',
            name:'/appointment',
            component: () => import("@/pages/MyCounselor/AppointmentInformation.vue")
        },
        // 预约订单
        {
            path: '/appointmentOrder',
            name:'/appointmentOrder',
            component: () => import("@/pages/MyCounselor/AppointmentOrder.vue")
        },
        // 私信列表
        {
            path: '/message',
            name:'/message',
            component: () => import("@/pages/MyCounselor/PrivateMessageList.vue")
        },
        // 问答大厅
        {
            path: '/question',
            name:'/question',
            component: () => import("@/pages/MyCounselor/QuestionAndAnswerHall.vue")
        },
        // 黑名单列表
        {
            path: '/black',
            name:'/black',
            component: () => import("@/pages/MyCounselor/BlacksList.vue")
        },
        // 个人评价
        {
            path: '/evaluation',
            name:'/evaluation',
            component: () => import("@/pages/MyCounselor/PersonalEvaluation.vue")
        },
        {
            path: "/blank",
            component: () => import("@/pages/blank/blankIndex.vue")
        },
    ]
})

export default router;